/** @jsx jsx */
import { jsx } from '@emotion/react';
import { PureComponent } from 'react';
import { AutoComplete as AutoCompleteAnt, Input, AutoCompleteProps } from 'antd';
import { AIcon as Icon } from '../icon';
import { get, size } from 'lodash';

interface IProps extends AutoCompleteProps {
  useDefaultFilter?: boolean;
  useSizeCompare?: boolean;
}
export class AutoComplete extends PureComponent<IProps> {
  static defaultProps: IProps;
  /* AER-1732: `disabled` was never inspected, so the re-render that should
     re-enable the control was suppressed. On Add/Edit Service Record the
     Services box therefore stayed disabled after clicking Edit until some
     unrelated update slipped through — removing a chip grows the `dataSource`,
     which changes its size and incidentally lets the update in. `placeholder`
     had the same hole. The sibling shared `Select` (`src/_shared/select`)
     already compares `disabled` for exactly this reason.
     The AER-1604 `useSizeCompare` gate on `dataSource` stays: the scheduling
     dropdown rebuilds that array on every render and Pusher tick, and
     re-rendering on identity alone wiped the user's in-progress search. */
  shouldComponentUpdate(nextProps: IProps) {
    return (
      nextProps.value !== this.props.value ||
      nextProps.disabled !== this.props.disabled ||
      nextProps.placeholder !== this.props.placeholder ||
      (nextProps.dataSource !== this.props.dataSource &&
        (!this.props.useSizeCompare ||
          size(nextProps.dataSource) !== size(this.props.dataSource)))
    );
  }
  render() {
    return (
      <AutoCompleteAnt 
        filterOption={this.props.useDefaultFilter ? (inputValue, option) => {
          return (
            `${get(option, 'props.children', '')}`
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          );
        } : undefined} {...this.props}>
        <Input suffix={<Icon type="down" />} />
      </AutoCompleteAnt>
    );
  }
}

AutoComplete.defaultProps = {
  useSizeCompare: true,
} as IProps;